/* eslint-disable @typescript-eslint/no-explicit-any */
import type { PropertyValue } from '@/types'
import { type Property } from '@/types'
import { getTranslate } from '@/utils/api-interceptors'
import { getPath } from '@/utils/next-util'
import { Listbox } from '@headlessui/react'
import type { Dispatch, SetStateAction } from 'react'
import { useEffect, useState } from 'react'
import ImageOptimize from '../ImageOptimize'

interface FilterDataProps {
  name: string
  values: PropertyValue[] | string[]
  value: any
  data: PropertyValue[]
}
export interface FilterItemGeneral {
  className?: string
  filterGroup: Property
  title?: string
  filterKey?: string
  selectedFilterByKey: (params: any) => void
  filterData: FilterDataProps[]
  setFetchFilter: Dispatch<SetStateAction<boolean>>
  fetchFilter: boolean
  setFilterData: Dispatch<SetStateAction<FilterDataProps[]>>
}
export const FilterItemGeneral = ({
  title,
  className,
  filterGroup,
  selectedFilterByKey = () => true,
  filterKey,
  filterData,
  fetchFilter,
  setFetchFilter,
}: FilterItemGeneral) => {
  const [selected, setSelected] = useState<FilterDataProps[]>([])
  function onChangeFilter(e: FilterDataProps[]) {
    setSelected(e)
    selectedFilterByKey([{ name: filterKey, values: e, value: null }])
    setFetchFilter(true)
  }
  useEffect(() => {
    filterData.map((e: any) => {
      if (e.name === getPath(filterGroup.slugs)) {
        setSelected([...e.values])
      }
    })
  }, [filterData, filterGroup, fetchFilter])
  return (
    <div className={`${className ? className : ''} `}>
      <Listbox value={selected} onChange={onChangeFilter} multiple>
        <Listbox.Button className='mb-2  text-sm font-bold text-dark-800'>
          {title}
        </Listbox.Button>

        <Listbox.Options
          as='div'
          static
          className='flex w-full cursor-pointer flex-wrap items-start justify-start gap-x-2.5 gap-y-1.5  text-sm'
        >
          {filterGroup.values.map((attribute, attributeIdx) => (
            <Listbox.Option
              as='div'
              key={attributeIdx}
              className={({ selected }) =>
                `relative flex h-10 items-center rounded-lg border bg-white  text-sm ${
                  selected ? 'border-primary-base' : 'border-dark-200'
                } hover:border-primary-base hover:text-primary-base`
              }
              value={getTranslate(attribute.value)}
            >
              {filterGroup?.slugs?.postfix === '-brand' ? (
                <ImageOptimize
                  src={attribute?.image}
                  alt={getTranslate(attribute.value)}
                  width={90}
                  height={20}
                  className='h-5 w-auto px-1'
                />
              ) : (
                <span className={`block truncate px-2`}>
                  {getTranslate(attribute.value)}
                </span>
              )}
            </Listbox.Option>
          ))}
        </Listbox.Options>
      </Listbox>
    </div>
  )
}
